import { Link, Route, Switch } from "react-router-dom";
import { BaseSubscriptions } from "./BaseSubscriptions/BaseSubscriptions";
import { Services } from "./Services";
import { TrackingCategories } from "./TrackingCategories";
import TaxRatesManager from "../TaxRates/TaxRatesManager";
import TieredUnitCountTimelineContainer from "./TieredUnitTimeline/TieredUnitCountTimelineContainer";

export const ProductManager = () => {
  return (
    <>
      <Switch>

        <Route path="/products/services"><Services /></Route>
        <Route path="/products/subscription_types"><BaseSubscriptions /></Route>
        <Route path="/products/tracking_categories"><TrackingCategories /></Route>
        <Route path="/products/taxes_by_province"><TaxRatesManager /></Route>
        <Route path="/products/tiered_unit_count_timeline"><TieredUnitCountTimelineContainer /></Route>
        <Route path="/products">
          <header className="Section-header">Product Manager</header>
          <ul>
            <li><Link to="/products/services">Services</Link></li>
            <li><Link to="/products/subscription_types">Base Subscriptions</Link></li>
            <li><Link to="/products/tracking_categories">Tracking Categories</Link></li>
            <li><Link to="/products/taxes_by_province">Taxes by Province</Link></li>
            <li><Link to="/products/tiered_unit_count_timeline">Tiered Unit Count Timeline</Link></li>
          </ul>
        </Route>

      </Switch>

    </>
  );
};